module.exports = __webpack_public_path__ + "static/media/背景色_02.5faf5872.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/背景色_02.jpg
// module id = 937
// module chunks = 0